(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kh-product-sticky"] && !Shopify.designMode) return;
  try {
    
(function(){
  var bar = document.getElementById('khPdpSticky');
  if (!bar) return;
  var btn = bar.querySelector('[data-kh-pdp-atc]');
  function findMainAtc(){ return document.querySelector('form[id^="BuyButtons-ProductForm"] button[type="submit"], form[action*="/cart/add"] button[type="submit"]'); }
  if (btn){ btn.addEventListener('click', function(e){ e.preventDefault(); var main = findMainAtc(); if (main){ main.click(); } }); }
  function syncDisabled(){ var main = findMainAtc(); if (!main || !btn) return; btn.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true'; }
  syncDisabled(); setInterval(syncDisabled, 800);
  function setVisible(visible){ if (visible){ bar.classList.add('kh-pdp-sticky--show'); bar.setAttribute('aria-hidden', 'false'); document.body.classList.add('kh-pdp-sticky-active'); var h = bar.offsetHeight; if (h) document.documentElement.style.setProperty('--kh-sticky-h', h + 'px'); } else { bar.classList.remove('kh-pdp-sticky--show'); bar.setAttribute('aria-hidden', 'true'); document.body.classList.remove('kh-pdp-sticky-active'); } }
  function checkPos(){ var main = findMainAtc(); if (!main){ setVisible(false); return; } var rect = main.getBoundingClientRect(); var scrolledPast = rect.bottom < 0; var nearFooter = (window.scrollY || window.pageYOffset) + window.innerHeight > document.documentElement.scrollHeight - 240; setVisible(scrolledPast && !nearFooter); }
  window.addEventListener('scroll', checkPos, { passive: true });
  window.addEventListener('resize', checkPos, { passive: true });
  setTimeout(checkPos, 400);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kh-shop-by"] && !Shopify.designMode) return;
  try {
    
class KHShopBy{constructor(el){this.el=el;this.toggle=el.querySelector('[data-kh-shop-toggle]');this.panel=el.querySelector('[data-kh-shop-panel]');this.closers=el.querySelectorAll('[data-kh-shop-close]');this.toggle.addEventListener('click',()=>this.open());this.closers.forEach(c=>c.addEventListener('click',()=>this.close()));document.addEventListener('keydown',e=>{if(e.key==='Escape')this.close()})}
open(){this.panel.hidden=false;requestAnimationFrame(()=>{this.panel.dataset.state='open';this.el.dataset.open='true';this.toggle.setAttribute('aria-expanded','true');document.documentElement.style.overflow='hidden'})}
close(){this.panel.dataset.state='closed';this.el.removeAttribute('data-open');this.toggle.setAttribute('aria-expanded','false');document.documentElement.style.overflow='';setTimeout(()=>{this.panel.hidden=true},420)}}
document.querySelectorAll('[data-kh-shop-by]').forEach(el=>new KHShopBy(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
